var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 1.82V12.18C0 12.97 0.87 13.45 1.54 13.02L9.68 7.84C10.3 7.45 10.3 6.55 9.68 6.15L1.54 0.98C0.87 0.55 0 1.03 0 1.82Z","fill":"currentColor"}));
}

Play.defaultProps = {"viewBox":"0 0 11 14"};

module.exports = Play;

Play.default = Play;
